import { useTheme } from "next-themes"
import { Toaster as Sonner, toast as sonnerToast } from "sonner"
import { CheckCircle2, XCircle, Info, AlertTriangle, Loader2 } from "lucide-react"
import React from "react"

// Custom icons keep the visual language coherent with the app.
const ICONS = {
  success: <CheckCircle2 className="w-4 h-4" strokeWidth={2.2} />,
  error:   <XCircle className="w-4 h-4" strokeWidth={2.2} />,
  info:    <Info className="w-4 h-4" strokeWidth={2.2} />,
  warning: <AlertTriangle className="w-4 h-4" strokeWidth={2.2} />,
  loading: <Loader2 className="w-4 h-4 animate-spin" strokeWidth={2.2} />,
}

const Toaster = ({
  ...props
}) => {
  const { theme = "system" } = useTheme()

  return (
    <Sonner
      theme={theme}
      className="toaster group"
      position="top-right"
      offset={16}
      gap={8}
      duration={4000}
      closeButton={false}
      icons={ICONS}
      toastOptions={{
        classNames: {
          toast:
            "group toast group-[.toaster]:shadow-2xl",
          title: "text-sm font-semibold",
          description: "text-xs opacity-80 mt-0.5",
          actionButton:
            "group-[.toast]:bg-[#D4FF00] group-[.toast]:text-black group-[.toast]:font-semibold",
          cancelButton:
            "group-[.toast]:bg-transparent group-[.toast]:text-zinc-400",
        },
      }}
      {...props} />
  );
}

// Re-export the vanilla toast — pages call `toast.success('...')` etc.
export { Toaster, sonnerToast as toast }
